import { render, staticRenderFns } from "./guessing-gold.vue?vue&type=template&id=89bb879c&scoped=true&"
import script from "./guessing-gold.vue?vue&type=script&lang=js&"
export * from "./guessing-gold.vue?vue&type=script&lang=js&"
import style0 from "./guessing-gold.vue?vue&type=style&index=0&id=89bb879c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bb879c",
  null
  
)

export default component.exports